import React from "react";
import { TicketDetails } from "../../../hooks/posts";

export interface TicketContextProps {
  ticketDetails: TicketDetails;
}

export const TicketContext = React.createContext<TicketContextProps>({
  ticketDetails: null
});
